"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : SEARCH BAR : STYLES --------------- ++++++++++ */


var _default = {
  searchbar: {
    display: 'flex',
    zIndex: '2',
    border: (0, _index.replacePXinStringWithEM)("1px solid transparent"),
    background: _index.theme.color.supporting.light.swatch,
    height: (0, _index.pxToEm)(56),
    // can be overridden at the project level, category and search will fill this vertical space
    '& .search': {
      padding: (0, _index.replacePXinStringWithEM)("0 0 0 ".concat((0, _index.pxToEm)(10))),
      margin: '0',
      display: 'flex',
      alignItems: 'center',
      alignContent: 'flex-start',
      position: 'relative',
      color: _index.theme.color.neutral.dark.swatch,
      background: _index.theme.color.supporting.light.swatch,
      transition: _index.theme.animation.general('all'),
      height: '100%',
      width: '100%',
      '&:hover': {
        filter: 'brightness(97%)'
      }
    },
    '& .icon': {
      color: 'rgb(6, 43, 117, .4)',
      width: (0, _index.pxToEm)(26),
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },
    '& .field': {
      flex: '1',
      '& input': {
        backgroundColor: 'transparent',
        border: '0',
        color: 'inherit',
        fontSize: (0, _index.pxToEm)(16),
        width: '100%',
        margin: '0',
        padding: '0',
        outline: 'none',
        '&::placeholder': {
          color: _index.theme.color.supporting.dark.swatch,
          opacity: '.4'
        }
      }
    }
  }
};
exports.default = _default;